import React from "react";
import { SnackbarProvider } from "notistack";
import MaybeAbstractComponent from "../../Components/maybeAbstractComponent";

const MaybeAbstractPage = () => {
  return (
    <SnackbarProvider>
      <div className="main-wrapper">
        <div className="content-wrapper">
          <MaybeAbstractComponent />
        </div>
      </div>
    </SnackbarProvider>
  );
};

export default MaybeAbstractPage;
